import { Link } from 'react-router-dom';

import ArticleSidebarItem, { ArticleSidebarContent } from './ArticleSidebarItem';

type Props = {
  popularArticles: ArticleSidebarContent[];
  newsArticles: ArticleSidebarContent[];
  events: ArticleSidebarContent[];
  onNavigateToNews: () => void;
  onNavigateToEvents: () => void;
};

export default function ArticleSidebar({
  popularArticles,
  newsArticles,
  events,
  onNavigateToNews,
  onNavigateToEvents,
}: Props) {
  return (
    <aside className='inline-flex h-full w-[240px] flex-[0_0_auto] flex-col gap-12 border-l border-l-gray-200 bg-gray-50 px-4 py-6 align-top lg:flex lg:w-full lg:px-[22px] lg:py-[34px]'>
      <ArticleSidebarItem
        title='開催予定のイベント'
        contents={events}
        noContentMessage='直近のイベントがありません。'
        navigateButtonLabel='イベント一覧'
        onNavigate={onNavigateToEvents}
      />

      <div className=''>
        <h2 className='mb-3 text-sm font-semibold'>人気の記事ランキング</h2>
        {popularArticles.length > 0 ? (
          <ul className='flex flex-col gap-1'>
            {popularArticles.map((article, index) => (
              <li
                className='rounded-md bg-white'
                key={index}
              >
                <Link
                  to={article.to}
                  className='flex gap-2 px-[13px] py-3 transition-colors hover:text-primary-500'
                >
                  <span className='font-montserrat text-sm font-semibold text-primary-500'>
                    {index + 1}
                  </span>
                  <p className='line-clamp-2 text-xs font-medium leading-[1.6]'>{article.title}</p>
                </Link>
              </li>
            ))}
          </ul>
        ) : (
          <p className='text-xs text-gray-500'>人気の記事がありません。</p>
        )}
      </div>

      <ArticleSidebarItem
        title='お知らせ'
        contents={newsArticles}
        noContentMessage='お知らせがありません。'
        navigateButtonLabel='お知らせ一覧'
        onNavigate={onNavigateToNews}
      />
    </aside>
  );
}
